// extracted by mini-css-extract-plugin
export default {"resultButtonContent":"styles_resultButtonContent__ST988","resultButton":"styles_resultButton__OXDGe"};